import { isNgTemplate } from '@angular/compiler';
import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import { barChartData } from 'app/core/interfaces/chart';
import { BaseComponent } from 'app/modules/shared/components/base.component';


declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'page-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent extends BaseComponent implements OnInit {

  @Input() public usuario: number = 0;
  @Input()  public itens: barChartData[] = [];

  public options: any = {
    chart: {
      type: 'column',
      height: 450
    },
    title: {
      text: ''
  },
  yAxis: {
    allowDecimals: false,
    reversed: false,
    min: 1,
   startOnTick: false,
    title: {
        text: ''
    }
  },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: []
    },    
    series: [],
    responsive: {
      rules: [{
          condition: {
              maxWidth: 500
          }          
      }]
  }
  }

  ngOnInit() {
    if (this.itens.length == 0) {
      this.itens = this.setChartDummyData();
    }     
    this.getConsultas();
  }

  public getConsultas() {
    //this.resultadoService.getUserResults(this.usuario).subscribe(data => {        
      let range: any = [];
      let values: any = [];
      this.itens.map((item:barChartData) => {
        range.push(moment(item.date, 'YYYY-MM-DD' ).format('DD/MM/YYYY'));
        values.push(item.value);
      });
      this.options.xAxis.categories = range.reverse().slice(0,12);
      this.options.series = [{name: 'Consultas', color: '#1d3d63', data: values.reverse().slice(0,12)}];
      Highcharts.chart('container', this.options);
      
    //});
  }  

  

}
